import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { updateCustomField } from 'utils/proposals'
import ScheduleEditor from 'components/ScheduleEditor'
import Spacer from 'atoms/Spacer'
import Fade from '@material-ui/core/Fade'
import Radio from '@material-ui/core/Radio'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Typography from '@material-ui/core/Typography'
import FieldLayout from '../FieldLayout'

export default class LiveChatAvailabilityEditor extends Component {
  static propTypes = {
    field: PropTypes.object.isRequired,
    normalizedFields: PropTypes.array.isRequired,
    onProposalUpdate: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)
    const schedule = this.getSchedule()
    this.state = {
      savedValue: [],
      alwaysAvailable: !schedule.length
    }
  }

  getSchedule = () => {
    const { field: { value = [] } } = this.props
    return value
  }

  handleScheduleChange = (value) => {
    const { field, normalizedFields, onProposalUpdate } = this.props
    onProposalUpdate({
      data: {
        fields: updateCustomField(normalizedFields, field.key, { value })
      }
    })
  }

  handleDelete = () => {
    const { onDelete } = this.props
    onDelete()
  }

  toggleAlwaysAvailable = () => {
    const schedule = this.getSchedule()
    const { savedValue, alwaysAvailable } = this.state
    if (!alwaysAvailable) {
      this.setState({ alwaysAvailable: true, savedValue: schedule })
      this.handleScheduleChange([])
    } else {
      this.handleScheduleChange(savedValue)
      this.setState({ alwaysAvailable: false, savedValue: [] })
    }
  }

  render() {
    const schedule = this.getSchedule()
    const { alwaysAvailable } = this.state
    return (
      <Fragment>
        <Spacer />
        <FieldLayout title="Availability" onDelete={this.handleDelete}>
          <FormControlLabel
            checked={alwaysAvailable}
            onChange={this.toggleAlwaysAvailable}
            control={<Radio color="primary" />}
            label={(
              <Fragment>
                <Typography>
                  Available 24/7
                </Typography>
                <Typography variant="caption" color="textSecondary">
                  Visitors will be able to initiate a live chat at any time
                </Typography>
              </Fragment>
            )}
          />
          <FormControlLabel
            checked={!alwaysAvailable}
            onChange={this.toggleAlwaysAvailable}
            control={<Radio color="primary" />}
            label={(
              <Fragment>
                <Typography>
                  Specify availability
                </Typography>
                <Typography variant="caption" color="textSecondary">
                  Visitors will only be able to initiate a live chat during these hours
                </Typography>
              </Fragment>
            )}
          />
          { !alwaysAvailable && (
            <Fade in>
              <div>
                <Spacer small />
                <ScheduleEditor
                  schedule={schedule}
                  onChange={this.handleScheduleChange}
                  addFormTitle="Add availability"
                  editFormTitle="Edit availability"
                />
              </div>
            </Fade>
          ) }
        </FieldLayout>
      </Fragment>
    )
  }
}
